import { IonContent, IonIcon, IonLabel, IonPage, IonSegmentButton, IonSlide, IonSlides } from '@ionic/react';
import { documentOutline, folderOutline, giftOutline } from 'ionicons/icons';
import { useEffect, useRef, useState } from 'react';
import { RouteComponentProps, useHistory } from 'react-router';
import LoadingContainer from '../../components/loading/LoadingContainer';

import Segment from '../../components/segments/Segment';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { CampaignTreeDocAction } from '../../redux/actions/Campaign';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import GiftDocs from './tree-documents/GiftDoc';
import NewDoc from './tree-documents/NewDoc';
import OldDocs from './tree-documents/OldDocs';

import './TreeDocuments.css';
import Plates from './tree-documents/Plates';

interface Props extends RouteComponentProps<{
    campaign_id: string
}> { }

const TreeDocuments: React.FC<Props> = ({ match }, props) => {
    const history = useHistory();
    const dispatch = useAppDispatch()

    const slideValues = ["online", "offline", "gift", "plate"]
    const [defaultSlide, setDefaultSlide] = useState("online");
    const sliderRef = useRef<HTMLIonSlidesElement>(null);

    const { loading, documents } = useAppSelector(state => state.campaignTreeDocuments);

    const [seedlings, setSeedlings] = useState(null as any);
    const [docs, setDocs] = useState(null as any);
    const [gifts, setGifts] = useState(null as any);
    const [plates, setPlates] = useState(null as any);
    const [donations, setDonations] = useState(null as any);
    const [templates, setTemplates] = useState(null as any);

    useEffect(() => {
        dispatch(CampaignTreeDocAction(match.params.campaign_id))
    }, [dispatch])

    useEffect(() => {
        setDocs(documents?.docs);
        setDonations(documents?.donations);
        setGifts(documents?.gifts)
        setPlates(documents?.plates)
        setTemplates(documents?.templates)
        setSeedlings(documents?.seedlings);
    }, [loading])

    const segmentClickHandler = (value: any) => {
        setDefaultSlide(value)

        let index = slideValues.findIndex((item) => {
            return item == value
        })

        sliderRef.current?.slideTo(index);
    }

    const slideChangeHandler = async () => {
        var index = await sliderRef.current?.getActiveIndex()
        setDefaultSlide(slideValues[index as number])
    }

    const changeDocsHandler = (docs: any, seedlings: any) => {
        if (seedlings != null)
            setSeedlings(seedlings);
        setDocs(docs);
    }

    const View = <LoadingContainer loading={loading}>
        <IonPage className="monthly-payment">
            <Toolbar title={"سند/پلاک درخت"} hasBackButton></Toolbar>

            <LayoutGap />

            <IonContent className="main-content">
                <Segment defaultSlide={defaultSlide} change={(e: any) => segmentClickHandler(e.detail.value)}>
                    <IonSegmentButton value="online">
                        <IonLabel>جدید</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="offline"><IonLabel>قبلی</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="gift"><IonLabel>سند دریافتی</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="plate"><IonLabel>پلاک ها</IonLabel></IonSegmentButton>
                </Segment>

                <IonSlides ref={sliderRef} onIonSlideDidChange={slideChangeHandler}>
                    <IonSlide>
                        <NewDoc project_id={match.params.campaign_id} templates={templates} docs={docs} seedlings={seedlings} donations={donations} changeDocs={changeDocsHandler} />
                    </IonSlide>
                    <IonSlide>
                        <OldDocs project_id={match.params.campaign_id} templates={templates} docs={docs} seedlings={seedlings} changeDocs={changeDocsHandler} />
                    </IonSlide>
                    <IonSlide>
                        <GiftDocs docs={gifts} />
                    </IonSlide>
                    <IonSlide>
                        <Plates items={plates} />
                    </IonSlide>
                </IonSlides>
            </IonContent>
        </IonPage>
    </LoadingContainer>;

    return View
}

export default TreeDocuments